// The page-wide rules for the styled dropdowns — 05j-2 (main.js's, 1:1): opening one closes
// any other open one, and a click outside a dropdown closes it. Each open StyledSelect
// registers its close here, so one listener serves every dropdown (main.js: "without each
// render stacking a new document listener").

import { flushSync } from "react-dom";

// Keyed by the dropdown's `.styled-select-wrap`.
const openMenus = new Map<HTMLElement, () => void>();

export function menuOpened(wrap: HTMLElement, close: () => void): void {
  openMenus.set(wrap, close);
}

export function menuClosed(wrap: HTMLElement): void {
  openMenus.delete(wrap);
}

// Synchronous, as main.js's classList.remove('open') was: the menu is shut before the rest
// of the click runs.
function closeWhere(keep: (wrap: HTMLElement) => boolean): void {
  const closes = [...openMenus].filter(([wrap]) => !keep(wrap)).map(([, close]) => close);
  if (closes.length) flushSync(() => closes.forEach((close) => close()));
}

/** A trigger was pressed: shut every other open dropdown. */
export function closeOtherMenus(wrap: HTMLElement): void {
  closeWhere((w) => w === wrap);
}

/** The outside-click close — installed just before main.js loads, where main.js added it
 *  (after the side panel's document click). */
export function installStyledSelectOutsideClick(): void {
  document.addEventListener("click", (e) => {
    const target = e.target instanceof Node ? e.target : null;
    closeWhere((wrap) => target !== null && wrap.contains(target));
  });
}
